export type WorkspaceNavigationGuard = () => Promise<boolean>;

let activeGuard: WorkspaceNavigationGuard | null = null;
let guardedHref: string | null = null;

export function registerWorkspaceNavigationGuard(
  guard: WorkspaceNavigationGuard,
): () => void {
  activeGuard = guard;
  guardedHref = window.location.href;
  return () => {
    if (activeGuard === guard) {
      activeGuard = null;
      guardedHref = null;
    }
  };
}

export function hasWorkspaceNavigationGuard(): boolean {
  return activeGuard !== null;
}

export async function confirmWorkspaceNavigation(): Promise<boolean> {
  return activeGuard ? activeGuard() : true;
}

export function workspaceNavigationGuardHref(): string | null {
  return guardedHref;
}
